import { useCallback } from 'react';

import { type Library } from '@air/api/types';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackJoinedLibrary.meta';

export type UseTrackRequestedLibraryAccessParams = {
  library_id: Library['id'];
};

export const useTrackRequestedLibraryAccess = () => {
  const { track } = useAnalyticsUtilities();

  const trackRequestedLibraryAccess = useCallback(
    (params: UseTrackRequestedLibraryAccessParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackRequestedLibraryAccess };
};
